import React, { useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import { pdfjs } from 'react-pdf';
import { withNamespaces } from 'react-i18next';
import PdfViewer from '@shared/pdfViewer/PdfViewer';
import { download } from '@utils/download';
import AlertAlgo from '@controls/AlertSnack';
import { getReportDefinition, getReportTitleByReportType } from '@actionsShared/report';
import LoadingLayer from '@controls/LoadingLayer';
import { reportTypes } from '@utils/reportHelper';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ReportViewer(props) {

    const classes = useStyles();
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [reportTitle, setReportTitle] = React.useState('');
    const [reportFileName, setReportFileName] = React.useState('');
    const [data, setData] = React.useState(null);
    const { open, onClose, reportType, reportParameters, zIndex } = props;
    const alertRef = useRef(null);

    useEffect(() => {
        const title = getReportTitleByReportType(reportType, reportParameters);
        setReportTitle(title);
        setReportFileName(`${title}.pdf`);
    }, [reportType]);

    useEffect(() => {
        if (!open) {
            setReportTitle(null);
            setReportFileName(null);
            setData(null);
        } else {
            setIsProcessing(true);
        }
    }, [open]);

    useEffect(() => {
        if (open
            && reportType != reportTypes.FlAG
            && reportParameters != null) {
            getReportDefinition(reportType, encodeURIComponent(JSON.stringify(reportParameters))).then((response) => {
                if (response == null) {
                    setIsProcessing(false);
                    return;
                }

                const title = getReportTitleByReportType(reportType, reportParameters);
                setReportTitle(title);
                setReportFileName(`${title}.pdf`);
                setData(response.reportData);
                setIsProcessing(false);
            });
        }
    }, [open], [reportType], [reportParameters]);

    const handleDownload = () => {
        const linkSource = `data:application/octet-stream;base64,${data}`;
        download(linkSource, reportFileName, 'application/octet-stream')
    }

    return (
        <React.Fragment>
            <LoadingLayer isActive={isProcessing}>
                <Dialog
                    fullScreen open={open}
                    onClose={onClose}
                    TransitionComponent={Transition}
                    style={zIndex ? { zIndex } : 1300}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.title}>
                                {reportTitle}
                            </Typography>
                            <IconButton edge="start" color="inherit" onClick={handleDownload} aria-label="download">
                                <GetAppIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    {data && <PdfViewer pdfData={data} />}
                </Dialog>
            </LoadingLayer>
            <AlertAlgo ref={alertRef} />
        </React.Fragment>
    )
}

export default withNamespaces(['popup', 'documents', 'error'], { wait: true })(ReportViewer);